import React, { useId, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from '@iconify/react';
import dangerIcon from '@iconify/icons-solar/danger-triangle-linear';
import { useModalDialog } from './useModalDialog';
import './feedback.css';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  pendingLabel?: string;
  cancelLabel?: string;
  busy?: boolean;
  error?: string;
  onCancel: () => void;
  onConfirm: () => void;
}
export default function ConfirmDialog({open,title,description,confirmLabel='Delete',pendingLabel='Deleting…',cancelLabel='Cancel',busy=false,error='',onCancel,onConfirm}: ConfirmDialogProps) {
  const ref = useRef<HTMLDialogElement>(null);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const titleId = useId(); const descriptionId = useId();
  useModalDialog(ref, open);
  useEffect(() => { if (open) cancelRef.current?.focus(); }, [open]);
  return createPortal(<dialog ref={ref} className="confirm-dialog" role="alertdialog" aria-labelledby={titleId} aria-describedby={descriptionId} aria-busy={busy} onCancel={e => { e.preventDefault(); if (!busy) onCancel(); }}>
    <div className="confirm-heading"><Icon icon={dangerIcon} width={23} aria-hidden="true"/><h2 id={titleId}>{title}</h2></div>
    <p id={descriptionId}>{description}</p>
    {error && <p className="confirm-error" role="alert">{error}</p>}
    <footer><button ref={cancelRef} type="button" className="feedback-button" onClick={onCancel} disabled={busy}>{cancelLabel}</button><button type="button" className="feedback-button feedback-danger" disabled={busy} onClick={onConfirm}>{busy ? pendingLabel : confirmLabel}</button></footer>
  </dialog>, document.body);
}
